'use client';

import type { ReactNode } from 'react';
import { useFieldContext } from '@/lib/form/contexts';

interface CheckboxProps {
  children: ReactNode;
}

export const Checkbox = ({ children }: CheckboxProps) => {
  const field = useFieldContext<boolean>();
  const error = field.state.meta.errors[0]?.message;
  return (
    <div>
      {/* The label keeps its normal colour on validation errors - the error
          message below is the red one. */}
      <label className="text-secondary flex cursor-pointer items-start gap-2.5 text-xs">
        {/* Box styling mirrors the live schuelerhilfe.de consent checkbox
            (Bootstrap `custom-checkbox`, measured off the Elternratgeber
            newsletter form): 20x20, 2px solid secondary border, 4px radius,
            transparent when unchecked, filled secondary with a white check
            when checked. `secondary` is #28190a in all three themes, which is
            the colour the live site uses. The live site draws its check at 50%
            of the box, but its glyph is a filled path that fills its viewBox;
            ours is a stroked polyline covering only ~2/3 of its 24 viewBox, so
            75% here yields the same visible mark size. */}
        <input
          type="checkbox"
          checked={field.state.value}
          onChange={(e) => field.handleChange(e.target.checked)}
          onBlur={field.handleBlur}
          className="border-secondary checked:bg-secondary h-5 w-5 shrink-0 cursor-pointer appearance-none rounded-sm border-2 bg-transparent checked:bg-[image:var(--icon-checkmark)] checked:bg-[length:75%] checked:bg-center checked:bg-no-repeat"
        />
        {/* `div`, not `span`: a consent label may be CMS rich text, whose
            paragraphs are flow content and must not sit inside a
            phrasing-content wrapper. Both are flex items of the label, so the
            computed display is unchanged. */}
        <div>{children}</div>
      </label>
      {error && (
        <p className="mt-2.5 pl-[30px] text-xs text-red-500">{error}</p>
      )}
    </div>
  );
};
